<template>
  <span
    v-if="statusObject"
    :class="{
      [`obs-ObjectiveStatus-${type}`]: type,
      'obs-ObjectiveStatus-loading': loading,
      'obs-ObjectiveStatus-noBorder': noBorder,
      'obs-ObjectiveStatus-with-icon': showStatusModeIcon
    }"
    :style="{
      color: statusObject.color,
      '--rgb-color': statusObject.rgbColor,
      '--border-color': statusObject.borderColor,
      '--ob-obs-background-color': statusObject.backgroundColor
    }"
    class="obs-ObjectiveStatus"
  >
    <AppIcon
      v-if="showStatusModeIcon"
      :icon-name="getIconName"
      class="obs-ObjectiveStatus_Icon"
      height="16"
      width="16"
    />
    <slot :label="$t(statusObject.label)">
      <span class="oboard-truncated-text">
        {{ $t(statusObject.label) }}
      </span>
    </slot>
    <slot name="after" />
    <SkeletonItem
      v-if="loading"
      :color="statusObject.color"
      border-radius="0"
      class="obs-ObjectiveStatus_Loader"
      height="100%"
      width="100%"
    />
  </span>
</template>

<script>
import { defineComponent } from 'vue'

import { STATUS_MODES_ICONS } from '@/utils/element-status'
import { OBJECTIVE_STATUS_ALL_OPTIONS } from '@/utils/objectives'
import { includesValue } from '@/utils/prop-validators'

import AppIcon from '@/components/ui/AppIcon/AppIcon'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

const TYPES = {
  DEFAULT: 'default'
}

export default defineComponent({
  name: 'ObjectiveStatus',

  components: {
    AppIcon,
    SkeletonItem
  },

  props: {
    status: {
      type: Number,
      required: true
    },

    type: {
      type: String,
      default: TYPES.DEFAULT,
      validator: v => includesValue(v, TYPES)
    },

    loading: {
      type: Boolean
    },

    noBorder: {
      type: Boolean
    },

    showStatusModeIcon: {
      type: Boolean
    },

    basedOnGrade: {
      type: Boolean
    }
  },

  computed: {
    statusObject() {
      return OBJECTIVE_STATUS_ALL_OPTIONS.find(option => option.value === this.status)
    },

    getIconName() {
      return this.basedOnGrade ? STATUS_MODES_ICONS.AUTO_SMALL : STATUS_MODES_ICONS.MANUAL_SMALL
    }
  }
})
</script>

<style lang="scss" scoped>
.obs-ObjectiveStatus {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: $system-ui;
  font-style: normal;
  font-weight: fw('bold');
  text-transform: var(--os-text-transform, uppercase);
  font-size: var(--os-font-size, #{$fs-12});
  line-height: 16px;
  padding: var(--padding, 2px 4px);
  border-radius: $border-radius-sm-next;
  white-space: nowrap;
  width: min-content;
  max-width: 100%;
  background-color: var(--ob-obs-background-color, transparent);

  &:not(&-noBorder) {
    border: 2px solid var(--border-color, rgba(var(--rgb-color), 0.3));
  }

  &-loading {
    position: relative;
  }

  &-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;

    --padding: 4px 8px 4px 4px;
  }
}

.obs-ObjectiveStatus_Loader {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
}

.obs-ObjectiveStatus_Icon {
  flex-shrink: 0;
}
</style>
